import {
    ADD_SESSION,
    ADD_TO_UNASSIGNED,
    CHANGE_SESSION_COLOR,
    DELETE_SESSION,
    LOAD_SESSIONS,
    REMOVE_FROM_UNASSIGNED,
    UPDATE_SESSION
} from "../actionTypes";
import {isBreakSession} from "../../commons";

const initialState = {
    sessionTypes: {},           // Object like {<sessionType>: {"fields" [...], ...}}
    byIds: {},                  // Object like {<session_id>: <session object>}
    areSessionsLoaded: false,
    unAssignedSessionIds: [],
    sessionColors: {}
};

export default function (state = initialState, action) {
    switch (action.type) {
        /* Adds a brand new session to the app */
        case ADD_SESSION: {
            const {session} = action.payload;
            const sessionId = session.id;
            return {
                ...state,
                unAssignedSessionIds: [...state.unAssignedSessionIds, sessionId],
                byIds: {
                    ...state.byIds,
                    [sessionId]: session
                },
                sessionColors: {
                    ...state.sessionColors,
                    [sessionId]: session.data.panel_color
                }
            };
        }
        /* Load a list of sessions, used once to fetch sessions from API */
        case LOAD_SESSIONS: {
            const {sessionTypes, sessions, unAssignedSessions} = action.payload;

            const byIds = {};
            for (const session of sessions) byIds[session.id] = session;

            const unAssignedSessionIds = [];
            for (const session of unAssignedSessions) if (!isBreakSession(session)) unAssignedSessionIds.push(session.id);

            const sessionColors = {};
            for (const session of sessions) sessionColors[session.id] = session.data.panel_color;

            return {
                ...state,
                sessionTypes,
                byIds,
                areSessionsLoaded: true,
                unAssignedSessionIds,
                sessionColors
            };
        }
        /* Push given session to unassigned list */
        case ADD_TO_UNASSIGNED: {
            const {sessions} = action.payload;
            const sessionIds = [];
            for (const session of sessions) if (!isBreakSession(session)) sessionIds.push(session.id);

            return {
                ...state,
                unAssignedSessionIds: [...state.unAssignedSessionIds, ...sessionIds],
            }
        }
        /* Removes specified session id from the list of unassigned sessions. */
        case REMOVE_FROM_UNASSIGNED: {
            const {sessionId} = action.payload;

            let newArray = state.unAssignedSessionIds.slice();
            const index = newArray.indexOf(sessionId);
            if (index > -1) newArray.splice(index, 1);

            return {...state, unAssignedSessionIds: newArray}
        }
        /* Update session object with the new representation */
        case UPDATE_SESSION: {
            const {sessionId, session} = action.payload;
            return {
                ...state,
                byIds: {
                    ...state.byIds,
                    [sessionId]: session
                },
                sessionColors: {
                    ...state.sessionColors,
                    [sessionId]: session.data.panel_color
                }
            }
        }
        /* Remove the session specified by sessionId */
        case DELETE_SESSION: {
            const {sessionId} = action.payload;

            let newArray = state.unAssignedSessionIds.slice();
            const index = newArray.indexOf(sessionId);
            if (index > -1) newArray.splice(index, 1);

            let {[sessionId]: session, ...byIds} = state.byIds;
            let {[sessionId]: color, ...sessionColors} = state.sessionColors;
            return {
                ...state,
                unAssignedSessionIds: newArray,
                byIds,
                sessionColors
            }
        }
        case CHANGE_SESSION_COLOR: {
            const {sessionId, colorPanel} = action.payload;
            return {
                ...state,
                sessionColors: {
                    ...state.sessionColors,
                    [sessionId]: colorPanel
                }
            };
        }
        default:
            return state;
    }
}
